module.exports = {
	ADD_STATIONS: 'ADD_STATIONS',
	SET_OLD_VALUE: 'SET_OLD_VALUE',
	SET_SELECTED_VALUE: 'SET_SELECTED_VALUE',
	SET_VISUALISATION: 'SET_VISUALISATION',
	SET_RADIUS: 'SET_RADIUS',
	PANEL_CITY: 'PANEL_CITY',
	PANEL_RADIUS: 'PANEL_RADIUS',
	PANEL_DRAW: 'PANEL_DRAW',
	PANEL_WATERMASS: 'PANEL_WATERMASS',
	PANEL_LAYER: 'PANEL_LAYER',
	SELECTED_TYPES: 'SELECTED_TYPES',
	SET_HOVER: 'SET_HOVER',
	RESET_RESEARCH: 'RESET_RESEARCH',
	RESET_STATIONS: 'RESET_STATIONS',
	SELECTED_STATIONS: 'SELECTED_STATIONS',
	RECEIVE_KEY_FIGURES: 'RECEIVE_KEY_FIGURES',
	RECEIVE_CITY_INDICATORS: 'RECEIVE_CITY_INDICATORS',
	RECEIVE_CITY_INFORMATIONS: 'RECEIVE_CITY_INFORMATIONS',
	RECEIVE_WATERSHED_SELECTED: 'RECEIVE_WATERSHED_SELECTED',
	PUT_STATIONS: 'PUT_STATIONS',
	WATERSHED_LAYERS: 'WATERSHED_LAYERS',
	UPDATE_WATERSHED_LAYERS: 'UPDATE_WATERSHED_LAYERS',
	MANAGEMENT_WATER_LAYERS: 'MANAGEMENT_WATER_LAYERS',
	UPDATE_MANAGEMENT_WATER_LAYERS: 'UPDATE_MANAGEMENT_WATER_LAYERS',
	CITIES_LAYERS: 'CITIES_LAYERS',
	DEPARTMENTS_LAYERS: 'DEPARTMENTS_LAYERS',
	UPDATE_CITIES_LAYERS: 'UPDATE_CITIES_LAYERS',
	RECEIVE_KEY_FIGURES_SAMPLING_POINTS: 'RECEIVE_KEY_FIGURES_SAMPLING_POINTS',
	RECEIVE_RESEARCH_TYPE: 'RECEIVE_RESEARCH_TYPE',
	MAP_RESEARCH: 'MAP_RESEARCH',
	HOME_PAGE_RESEARCH: 'HOME_PAGE_RESEARCH'
}



// WEBPACK FOOTER //
// ./src/sites/constants/SitesConstants.js